export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-Regular.86bc2a5a.otf";